/**
 *
 * LeftMenuButton
 *
 */

 import React from "react";
 import { A, StyledLink } from "./styledComponents";
 import Icon from "components/Icon";
 
 const Button = ({ home, name, resource, href, iconName, rel, target }) =>
   href ? (
     <A href={href} rel={rel} target={target}>
       {iconName && <Icon name={iconName} width="14" />}
       <span>{name || resource}</span>
     </A>
   ) : (
     <StyledLink to={`/${resource}`}>
       {iconName && <Icon name={iconName} width="14" />}
       <span>{name || resource}</span>
     </StyledLink>
   );
 
 export default Button;